import { Reveal } from "./Reveal";

// Numerowany nagłówek sekcji. H2: 40px/1.12 desktop, 30px/1.15 mobile (design tokens).
export const SectionHeading = ({ chapter, title, lead, align = "center", accentTitle, size = "md" }) => {
  const isCenter = align === "center";
  const titleSize =
    size === "lg"
      ? "text-[34px] leading-[1.12] tracking-[-0.02em] md:text-[46px] md:leading-[1.1] md:tracking-[-0.025em]"
      : "text-[30px] leading-[1.15] tracking-[-0.02em] md:text-[40px] md:leading-[1.12] md:tracking-[-0.025em]";
  return (
    <div className={isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      {chapter && (
        <Reveal>
          <span className="mb-4 inline-flex items-center gap-2 font-display text-xs font-semibold tracking-[0.08em] text-brand-accent">
            <span className="tabular-nums">{chapter}</span>
            <span className="h-px w-8 bg-brand-accent/50" />
          </span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className={`font-display font-semibold ${titleSize}`}>
          {title}
          {accentTitle && <span className="text-brand-accent">{accentTitle}</span>}
        </h2>
      </Reveal>
      {lead && (
        <Reveal delay={0.1}>
          <p className={`mt-4 text-[18px] leading-[1.55] text-brand-sec ${isCenter ? "mx-auto max-w-xl" : ""}`}>
            {lead}
          </p>
        </Reveal>
      )}
    </div>
  );
};
